import './About.css';
const About = () => {

  return (
    <div className='playlist-tabs-modern'>
      <div className='video-container'>
        <iframe
          src="https://www.youtube.com/embed/G8HPEAHk1so?si=pebd4WH5Fk2AoE5T&autoplay=1&mute=1"
          title="Banner Video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className='banner-video'
        ></iframe>
      </div>
    </div>
  );
}
export default About;